module.exports = __webpack_public_path__ + "media/src/images/app_icons/favicons/favicon-1d4a27475bd43ebefffb70b0947be224.ico";